<div class="row g-2">
  <div class="col-12" *ngFor="let session of sessionsWithMultiplePreferences; let i=index">
    <app-session-preference
      [session]=session
      [sessionPreferenceForm]="sessionPreferencesForm.controls[i]">
    </app-session-preference>
  </div>
</div>
